import { useNavigation } from "react-router";
import { useSpinDelay } from "spin-delay";

import { Progress } from "../nprogress/progress";

export const MeganavProgress = () => {
  const state = useNavigation();
  const isLoading = useSpinDelay(
    ["submitting", "loading"].includes(state.state),
    {
      delay: 600,
      minDuration: 200,
    },
  );
  return (
    <div className="absolute bottom-0 left-0 right-0 h-0.5 overflow-hidden">
      <div className="relative">
        <Progress isAnimating={isLoading} />
      </div>
    </div>
  );
};
